import React, {useState} from 'react';
import NameFormatter from '../NameFormatter';

function TableRow({member, index, page}) {

	const [height, setHeight] = useState(0);
	const [expandState, setExpandState] = useState(false);

	const toggleDownArrow = () => {
		if(expandState === true) {
			setHeight(0);
			return setExpandState(false);
		}
		const elementToExpand = document.getElementById('movement-container_inner-' + index).offsetHeight;
		setHeight(elementToExpand);
		setExpandState(true);
	};

	const FormatMultiplier = (number) => {
		if(number < 1) return number.toFixed(1);
		return number;
	};

	function numberWithCommas(x) {
		x = Math.round(x);
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	const sortFunction = (a, b) => {
		const arrayOfMovements = ['doubleunders', 'squats', 'situps', 'lunges', 'pushups', 'kbswings', 'burpees', 'pullups', 'run', 'row']
		// const multiplierA = a[1].points / a[1].volume;
		// const multiplierB = b[1].points / b[1].volume;
		const indexA = arrayOfMovements.indexOf(a[0]);
		const indexB = arrayOfMovements.indexOf(b[0]);
		if(indexA < indexB) return -1;
		return 1;
	}

	return (<div className={(index % 2 === 1 ? 'table-row-odd ' : '') + 'table-row flex w-100 items-center'}>
			<div className="athlete-column w-40 tl pv3 ph3 flex items-center">
				<div className="left-wrap flex items-center">
					<h2 className="ma0 ph2 f6">{(index + 1) + (20 * (page - 1))}.</h2>
					<img 
						alt={(member.member_name || member.gym_name) + ' image'}
						className={'avatars br-100 h2 w2 mh2'} src={(member.member_image_url || member.gym_image_url)} 
					/>
					{member.member_id &&
						<div className="hidden dn" id={'member_' + member.member_id}>{member.member_id}</div>
					}
				</div>
				<div className="name-score ph2">
					<h2 className="ma0 f6 name">
						{member.member_name || member.gym_name}
					</h2>
					<div className="flex items-center">
						<h5 className="mb0 f6 fw4 score tc">{numberWithCommas(member.points)} pts.</h5>
						<div 
							className={'expand-arrow w-100 tc ml3 pointer' + (expandState ? ' rotate-180' : '')}
							onClick={toggleDownArrow.bind(this)}>
							<svg 
								version="1.1" 
								id="Layer_1" 
								xmlns="http://www.w3.org/2000/svg" 
								x="0px" 
								y="0px"
								width="20" 
								viewBox="0 0 407.437 407.437" 
								style={{enableBackround: 'new 0 0 407.437 407.437'}}>
								<polygon points="386.258,91.567 203.718,273.512 21.179,91.567 0,112.815 203.718,315.87 407.437,112.815 "/>
							</svg>
						</div>
					</div>

				</div>

			</div>
			<div className="divider">
			</div>
			<div 
				className="movement-container w-60 flex flex-wrap justify-around items-center overflow-hidden"
				id={'movement-container' + index}
				style={{height: height}}>
				<div 
					className="movement-container__inner flex flex-wrap w-100 pl2"
					id={'movement-container_inner-' + index}>
					{(Object.entries(member.breakdown) || []).sort(sortFunction).map((movement, idx) => 
						<div className={'movement ' + (idx < 5 ? 'pt3 pb2' : 'pt2 pb3')} key={idx}>
							<span className="ttc number">{numberWithCommas(movement[1].volume)}{(movement[1].quantity) === 'distance_m' ? 'm' : ''}
								<span class="multiplier ttl"> (x{ 
									isNaN(movement[1].points / movement[1].volume) ? '-' : FormatMultiplier(movement[1].points / movement[1].volume) 
								})</span>
							</span>
							<span className="line-breaker title ttc">
								{NameFormatter(movement[0])}
							</span>
						</div>
					)}
				</div>
			</div>
		</div>)
};

export default TableRow;